import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';

// Compact picklist filter used in workstation page headers and filter bars: sits
// quietly as secondary text until focused, then picks up the accent border.
const FilterSelect = ({
	value = '',
	options = [],
	onChange,
	disabled = false,
	minWidth = 120,
	maxListHeight,
	'data-testid': dataTestId = 'filter-select',
	...selectProps
}) => (
	<Select
		data-testid={dataTestId}
		value={value}
		onChange={(event) => onChange?.(event.target.value)}
		disabled={disabled}
		displayEmpty
		size='small'
		sx={{
			minWidth,
				minHeight: 'unset',
				alignSelf: 'stretch',
			fontSize: 11,
			borderRadius: '6px',
			backgroundColor: 'background.paper',
			color: 'text.secondary',
			'& .MuiSelect-select': {
					padding: '0px 8px',
					height: '100%',
					display: 'flex',
					alignItems: 'center',
				},
			'& .MuiOutlinedInput-notchedOutline': {
				borderWidth: '0.5px',
				borderColor: 'border.main',
			},
			'&:hover .MuiOutlinedInput-notchedOutline': {
				borderColor: 'primary.main',
			},
			'&.Mui-focused': { color: 'text.primary' },
			'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
				borderWidth: '0.5px',
				borderColor: 'primary.main',
			},
		}}
		MenuProps={{
			slotProps: {
				paper: {
					sx: {
						borderRadius: '8px',
						border: '0.5px solid',
						borderColor: 'border.main',
						maxHeight: maxListHeight,
						overflowY: maxListHeight != null ? 'auto' : undefined,
						'& .MuiMenuItem-root': { fontSize: 12 },
					},
				},
			},
		}}
		{...selectProps}
	>
		{options.map((option) => {
			const item =
				typeof option === 'string' ? { label: option, value: option } : option;

			return (
				<MenuItem key={item.value} value={item.value}>
					{item.label}
				</MenuItem>
			);
		})}
	</Select>
);

FilterSelect.propTypes = {
	value: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.shape({
				label: PropTypes.string.isRequired,
				value: PropTypes.string.isRequired,
			}),
		])
	),
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	maxListHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	'data-testid': PropTypes.string,
};

export default FilterSelect;
